import React from 'react';
import usePageMeta from '../hooks/usePageMeta';
import { SITE_URL } from '../seo/site';
import StructuredData from '../components/StructuredData';
import WelcomeSection from '../components/WelcomeSection';
import AboutSection from '../components/AboutSection';
import BundleStrip from '../components/BundleStrip';
import ProductSection from '../components/ProductSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import FloatingParticles from '../components/FloatingParticles';
import Navigation from '../components/Navigation';

const HomePage = ({ content }) => {
  usePageMeta({
    title: content.site.title,
    description: content.site.description,
    canonical: `${SITE_URL}/`,
  });

  return (
    <>
      <StructuredData content={content} />
      <div className="home-page-wrapper">
        <WelcomeSection content={content.welcome} products={content.products} />
        <AboutSection content={content.about} />
        <BundleStrip bundle={content.bundle} products={content.products} />
        {content.products.map((product) => (
          <ProductSection key={product.id} product={product} />
        ))}
        <BundleStrip
          bundle={content.bundle}
          products={content.products}
          sectionId={null}
          variant="bottom"
        />
        <ContactSection content={content.contact} editingWork={content.about?.editingWork} />
        <Footer content={content.site} products={content.products} />
      </div>
      <FloatingParticles />
      <Navigation content={content.navigation} products={content.products} />
    </>
  );
};

export default HomePage;
